var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVimeLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124.34 38.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ViME",
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23,38.79H11.65L0,3.1H10.84L15.7,21.19a58.84,58.84,0,0,1,1.66,8.4c.13-1.22.36-2.69.71-4.42s.63-3,.88-3.88L23.88,3.1H34.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,1a5.82,5.82,0,0,1,3.83-1A5.87,5.87,0,0,1,46.7,1.06,4,4,0,0,1,48,4.25q0,4.2-5.08,4.2c-3.38,0-5.08-1.4-5.08-4.2A4,4,0,0,1,39,1Zm8.58,37.75H38V11.13h9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.46,38.79H86.6V23.14c0-1.13,0-2,0-2.69s.13-3.1.34-7.32h-.22l-7.2,25.66H70.36l-7.3-25.7h-.22c.34,4.37.51,7.78.51,10.2v15.5H54.81V3.1H67.65l7.42,25.34h.2L82.59,3.1H95.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.34,10.84H112.79v5.61h10.67v7.74H112.79v6.74h11.55v7.86H103.15V3.1h21.19Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeLogo);
export default __webpack_public_path__ + "static/media/VimeLogo.bed7293190bf41855689377f57020c94.svg";
export { ForwardRef as ReactComponent };